import React from 'react';

const Logo = ({ className = "h-20 w-auto" }) => {
  return (
    <img 
      src="/logo.svg"
      alt="FundedLab"
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default Logo;